module.exports = __webpack_public_path__ + "img/CX.8387d6ac.jpg";